export { UITrustQuoteStrip } from './UITrustQuoteStrip';
export type { UITrustQuoteStripProps } from './UITrustQuoteStrip';
